import React from 'react';
import { TableCell, TableCellProps } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';

import { styles } from '../stylesTable';

const CustomBodyTableCell = ({
  children,
  align = 'left',
  sx,
  ...rest
}: TableCellProps) => {
  const mergedSx = [
    styles.tableCell2,
    ...(Array.isArray(sx) ? sx : sx !== undefined && sx !== null ? [sx] : []),
  ] as SxProps<Theme>;

  return (
    <TableCell align={align} sx={mergedSx} {...rest}>
      {children}
    </TableCell>
  );
};

export default CustomBodyTableCell;
